var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15576 8.04285V19.5715L13.4522 13.8163L6.15576 8.04285Z",
    fill: "url(#paint0_linear_9557_28324)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.15576 7.35294L25.1844 0L10.9718 11.2382L6.15576 7.35294Z",
    fill: "url(#paint1_linear_9557_28324)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9718 11.2382L16.8741 6.55408L18.9924 17.647L10.9718 11.2382Z",
    fill: "url(#paint2_linear_9557_28324)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9924 17.6834L0 25L14.1583 13.8163L18.9924 17.6834Z",
    fill: "#464AEB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9557_28324",
    x1: 9.95458,
    y1: 10.2702,
    x2: 5.96485,
    y2: 17.0772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4748EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9557_28324",
    x1: 10.4196,
    y1: 7.57083,
    x2: 18.9021,
    y2: 1.35317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454AEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61C2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9557_28324",
    x1: 17.6402,
    y1: 4.0604,
    x2: 12.3772,
    y2: 14.7725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61C2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4649EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.2eb78f635f2ce959eb48bb942e0e6fdd.svg";
export { ForwardRef as ReactComponent };